import React from "react";
import { useLang } from "../LanguageContext";

function Home() {
  const { t } = useLang();
  const items = t("home.items");

  return (
    <div className="home">
      <div className="hero-card">
        <div className="hero-body">
          <div className="hero-content">
            <span className="section-label">{t("home.label")}</span>
            <h1>{t("home.title")}</h1>
            <p>{t("home.desc1")}</p>
            <p>{t("home.desc2")}</p>
            <ul className="hero-list">
              {Array.isArray(items) && items.map((item, i) => (
                <li key={i}>{item}</li>
              ))}
            </ul>
            <p className="muted hero-tech">{t("home.techStack")}</p>
          </div>

          <div className="hero-social">
            <a href="http://www.linkedin.com/in/kaisteuernagel" target="_blank" rel="noreferrer" className="social-pill">
              <svg width="15" height="15" viewBox="0 0 24 24" fill="currentColor">
                <path d="M16 8a6 6 0 016 6v7h-4v-7a2 2 0 00-2-2 2 2 0 00-2 2v7h-4v-7a6 6 0 016-6z"/>
                <rect x="2" y="9" width="4" height="12"/><circle cx="4" cy="4" r="2"/>
              </svg>
              LinkedIn
            </a>
            <a href="https://github.com/its-really-me" target="_blank" rel="noreferrer" className="social-pill">
              <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                <path d="M9 19c-5 1.5-5-2.5-7-3m14 6v-3.87a3.37 3.37 0 00-.94-2.61c3.14-.35 6.44-1.54 6.44-7A5.44 5.44 0 0020 4.77 5.07 5.07 0 0019.91 1S18.73.65 16 2.48a13.38 13.38 0 00-7 0C6.27.65 5.09 1 5.09 1A5.07 5.07 0 005 4.77a5.44 5.44 0 00-1.5 3.78c0 5.42 3.3 6.61 6.44 7A3.37 3.37 0 009 18.13V22"/>
              </svg>
              GitHub
            </a>
          </div>
        </div>
      </div>

      <div className="disclaimer-panel">
        <p className="disclaimer-note">{t("home.disclaimer")}</p>
      </div>
    </div>
  );
}

export default Home;
